import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog,{attrs:{"max-width":"1024","change":_vm.emitChange()},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('div',{staticClass:"business-kind-dialog"},[_c('business-kind',{on:{"nextStep":_vm.nextStep}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }